<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-notContain`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.03613 2.21959C9.16979 1.87763 9.55543 1.70912 9.89746 1.84264C10.2394 1.97633 10.409 2.36195 10.2754 2.70397L9.94434 3.54967C11.7866 4.1881 13.1094 5.9383 13.1094 7.99792C13.1093 10.5973 11.0026 12.7047 8.40332 12.7049H6.36914L5.9502 13.7782C5.81648 14.1199 5.43078 14.2885 5.08887 14.1551C4.74701 14.0214 4.5784 13.6358 4.71191 13.2938L4.94141 12.7049H3.55566C3.18845 12.7049 2.89071 12.4071 2.89062 12.0399C2.89062 11.6726 3.18839 11.3749 3.55566 11.3749H5.46094L8.09863 4.62096H3.55566C3.18845 4.62096 2.89071 4.32312 2.89062 3.95592C2.89062 3.58865 3.18839 3.29088 3.55566 3.29088H8.40332C8.47434 3.29089 8.54498 3.29265 8.61523 3.29577L9.03613 2.21959ZM6.88867 11.3749H8.40332C10.2681 11.3746 11.7802 9.86274 11.7803 7.99792C11.7803 6.50209 10.8073 5.2336 9.45996 4.78991L6.88867 11.3749Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineNotContain',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
